import React from "react";
import "./ComponentStyles.css"; // Import shared styles

const ActualBill = ({ selected }) => {
  return (
    <div className="component-card">
      <label className="checkbox-label">
        <input type="checkbox" disabled checked={selected} />
        <span></span> Actual Bill
      </label>
    </div>
  );
};

export default ActualBill;
